import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import "../../styles/components/categories/categoryNavigationComponent.scss";

export const CategoryNavigationComponent = ({ props }) => {
  const { categoryId, itemGroupId } = props;

  // Get all categories and item groups from the Redux state
  const categories = useSelector((state) => state.categoryReducer.categories?.items);
  const navigate = useNavigate();

  const getNavigationButtons = () => {
    if (!categories || !categoryId || !itemGroupId) return null;

    // Find current category and item group
    const currentCategoryIndex = categories.findIndex((category) => category.id === categoryId);
    if (currentCategoryIndex === -1) return null;

    const currentCategory = categories[currentCategoryIndex];
    const itemGroups = currentCategory.itemGroups || [];
    const currentItemGroupIndex = itemGroups.findIndex((group) => group.id === itemGroupId);

    // Determine previous and next item group
    const prevItemGroup = itemGroups[currentItemGroupIndex - 1];
    const nextItemGroup = itemGroups[currentItemGroupIndex + 1];

    // If no previous item group, get last item group from previous category
    let prevCategory = null;
    let prevCategoryLastItemGroup = null;
    if (!prevItemGroup && currentCategoryIndex > 0) {
      prevCategory = categories[currentCategoryIndex - 1];
      prevCategoryLastItemGroup = prevCategory.itemGroups?.[prevCategory.itemGroups.length - 1];
    }

    // If no next item group, get first item group from next category
    let nextCategory = null;
    let nextCategoryFirstItemGroup = null;
    if (!nextItemGroup && currentCategoryIndex < categories.length - 1) {
      nextCategory = categories[currentCategoryIndex + 1];
      nextCategoryFirstItemGroup = nextCategory.itemGroups?.[0];
    }

    return (
      <div className="groupNavigationContainer">
        {prevItemGroup ? (
          <button className="navButton prev" onClick={() => navigate(`/categories/${categoryId}/itemGroup/${prevItemGroup.id}`)}>
            <i className="fa-solid fa-arrow-right"></i> {prevItemGroup.itemGroupName}
          </button>
        ) : prevCategory && prevCategoryLastItemGroup ? (
          <button className="navButton prev" onClick={() => navigate(`/categories/${prevCategory.id}/itemGroup/${prevCategoryLastItemGroup.id}`)}>
            <i className="fa-solid fa-arrow-right"></i> {prevCategory.categoryName} - {prevCategoryLastItemGroup.itemGroupName}
          </button>
        ) : null}

        {nextItemGroup ? (
          <button className="navButton next" onClick={() => navigate(`/categories/${categoryId}/itemGroup/${nextItemGroup.id}`)}>
            {nextItemGroup.itemGroupName} <i className="fa-solid fa-arrow-left"></i>
          </button>
        ) : nextCategory && nextCategoryFirstItemGroup ? (
          <button className="navButton next" onClick={() => navigate(`/categories/${nextCategory.id}/itemGroup/${nextCategoryFirstItemGroup.id}`)}>
            {nextCategory.categoryName} - {nextCategoryFirstItemGroup.itemGroupName} <i className="fa-solid fa-arrow-left"></i>
          </button>
        ) : null}
      </div>
    );
  };

  return getNavigationButtons();
};

export default CategoryNavigationComponent;
